import qs from 'qs';

// TODO: Derive all arguments from state instead of passing them
export default (browserFingerprint) =>
  async ({ retailerName, locale, email, encryptedReturnId }) => {
    const urlBase = `/returns/${retailerName}/maillabel?`;
    const params = qs.stringify(
      {
        locale,
        return_id: encryptedReturnId,
        email_address: email,
      },
      { encode: false },
    );

    try {
      await fetch(`${urlBase}${params}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'narvar-tfid': browserFingerprint,
        },
      });

      return true;
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }

    return false;
  };
